import { SidenavItem } from "./menu-item";



export class SidenavCategory {
    categoryName: string;
    categoryRouteOrFunction?: any;
    categoryIcon?: string;
    categoryPosition?: number;
    categoryPathMatchExact?: boolean;
    categoryType?: 'item' | 'subheading';
    categoryCustomClass?: string;
    items: SidenavItem[] = [];
    categoryBadge?: string;
    categoryBadgeColor?: string;
    categoryParent?: SidenavCategory;
    isICategoryctive?: boolean;
    constructor() {
        this.categoryName = '';
    }

    jsonModel(json: any, repetive?: boolean) {
        this.categoryName = json.categoryName;
        this.categoryRouteOrFunction = (json.categoryRouteOrFunction) ? json.categoryRouteOrFunction : null;
        this.categoryIcon = (json.categoryIcon) ? json.categoryIcon : null;
        this.categoryPosition = json.categoryPosition;
        this.categoryPathMatchExact = json.categoryPathMatchExact ?? false;
        this.categoryType = (json.categoryType) ? json.categoryType : null;
        this.categoryCustomClass = (json.categoryCustomClass) ? json.categoryCustomClass : null;
        this.categoryBadge = (json.categoryBadge) ? json.categoryBadge : null;
        this.categoryBadgeColor = (json.categoryBadgeColor) ? json.categoryBadgeColor : null;
        if (!repetive) {
            if (json.items) {
                this.items = [];
                const auxItems: SidenavItem[] = [];
                let auxShow: boolean | undefined = false;
                json.items.forEach((x: any) => {
                    const subMenu = new SidenavItem();
                    subMenu.jsonModel(x);
                    auxItems.push(subMenu);
                    auxShow = auxShow || subMenu.isItemActive;
                });
                this.isICategoryctive = (auxItems.length) ? auxShow : true;
                this.items = auxItems.sort((a: SidenavItem, b: SidenavItem) => {
                    if (a.itemPosition < b.itemPosition) {
                        return 1;
                    } else {
                        return -1;
                    }
                });
            } else {
                this.items = [];
            }
        } else {
            this.items = [];
        }

    }

    

    getValue(label: string) {
        switch (label) {
            case 'categoryName':
                return this.categoryName;
            case 'categoryRouteOrFunction':
                return this.categoryRouteOrFunction;
            case 'categoryIcon':
                return this.categoryIcon;
            case 'categoryPosition':
                return this.categoryPosition;
            case 'categoryPathMatchExact':
                return this.categoryPathMatchExact;
            case 'categoryType':
                return this.categoryType;
            case 'categoryCustomClass':
                return this.categoryCustomClass;
            case 'items':
                return this.items;
            case 'categoryBadge':
                return this.categoryBadge;
            case 'categoryBadgeColor':
                return this.categoryBadgeColor;
            case 'categoryParent':
                return this.categoryParent;
            default:
                break;
        }
    }
}
